if (window.jQuery && jQuery.fn && jQuery.fn.fancybox) {
  $('[data-fancybox="gallery"]').fancybox({
  });
}

(function() {
  function getStickyHeaderOffset() {
    const rootStyles = window.getComputedStyle(document.documentElement);
    const headerBottomPosition = parseInt(rootStyles.getPropertyValue('--header-bottom-position'), 10);

    if (!Number.isNaN(headerBottomPosition) && headerBottomPosition > 0) {
      return headerBottomPosition;
    }

    const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height'), 10);

    if (!Number.isNaN(headerHeight) && headerHeight > 0) {
      return headerHeight;
    }

    const stickyHeader = document.querySelector('.shopify-section-header-sticky:not(.shopify-section-header-hidden)');

    if (!stickyHeader) {
      return 0;
    }

    return stickyHeader.getBoundingClientRect().height;
  }

  function getReviewsWidget() {
    return document.querySelector('.jdgm-widget');
  }

  function scrollToReviewsWidget() {
    const reviewsWidget = getReviewsWidget();

    if (!reviewsWidget) {
      return false;
    }

    const offset = getStickyHeaderOffset() + 16;
    const targetTop = reviewsWidget.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth'
    });

    return true;
  }

  function handleReviewsAnchorClick(event) {
    const anchor = event.target.closest('a[href="#reviews"]');

    if (!anchor) {
      return;
    }

    if (!scrollToReviewsWidget()) {
      return;
    }

    event.preventDefault();
    window.history.replaceState(null, '', '#reviews');

    const flyerInner = anchor.closest('.se-flyer__inner');

    if (!flyerInner) {
      return;
    }

    const flyer = flyerInner.closest('[data-se-flyer]');
    const closeButton = flyer && flyer.querySelector('[data-se-close]');

    if (closeButton) {
      closeButton.click();
    }
  }

  function handleReviewsHash() {
    if (window.location.hash !== '#reviews') {
      return;
    }

    window.setTimeout(scrollToReviewsWidget, 250);
  }

  document.addEventListener('click', handleReviewsAnchorClick);
  document.addEventListener('DOMContentLoaded', handleReviewsHash);
  window.addEventListener('hashchange', handleReviewsHash);
})();
